import { useState } from "react";
import { ArrowLeft, ArrowRight, Check, Loader2 } from "lucide-react";

export const Wizard = ({ steps, onSubmit, submitting, submitLabel = "Submit", testid }) => {
  const [i, setI] = useState(0);
  const last = i === steps.length - 1;
  const pct = Math.round(((i + 1) / steps.length) * 100);

  const next = () => setI((v) => Math.min(v + 1, steps.length - 1));
  const back = () => setI((v) => Math.max(v - 1, 0));

  return (
    <div data-testid={testid} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-9">
      {/* progress */}
      <div className="mb-8">
        <div className="mb-2 flex items-center justify-between">
          <span className="font-mono-x text-xs uppercase tracking-widest text-gold">
            Step {i + 1} of {steps.length} — {steps[i].title}
          </span>
          <span className="font-mono-x text-xs text-slate-400">{pct}%</span>
        </div>
        <div className="h-1.5 w-full overflow-hidden rounded-full bg-slate-100">
          <div className="h-full rounded-full bg-gold transition-all duration-500" style={{ width: `${pct}%` }} />
        </div>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {steps.map((s, idx) => (
            <button
              key={s.key}
              type="button"
              onClick={() => setI(idx)}
              className={`rounded-full px-2.5 py-1 text-[10px] font-medium transition-colors ${
                idx === i ? "bg-gold text-[#0B132B]" : idx < i ? "bg-gold/15 text-gold" : "bg-slate-100 text-slate-400"
              }`}
            >
              {idx < i && <Check className="mr-1 inline h-3 w-3" />}
              {s.key}
            </button>
          ))}
        </div>
      </div>

      <div className="min-h-[280px]">{steps[i].render()}</div>

      <div className="mt-8 flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={back}
          disabled={i === 0}
          data-testid="wizard-back-btn"
          className="inline-flex items-center gap-2 rounded-full border border-slate-300 px-5 py-2.5 text-sm font-medium text-slate-600 transition-colors hover:border-slate-400 disabled:opacity-40"
        >
          <ArrowLeft className="h-4 w-4" /> Back
        </button>

        {last ? (
          <button
            type="button"
            onClick={onSubmit}
            disabled={submitting}
            data-testid="wizard-submit-btn"
            className="inline-flex items-center gap-2 rounded-full bg-gold px-7 py-2.5 text-sm font-semibold text-[#0B132B] transition-all hover:bg-[#E5C158] disabled:opacity-60"
          >
            {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            {submitting ? "Submitting…" : submitLabel}
          </button>
        ) : (
          <button
            type="button"
            onClick={next}
            data-testid="wizard-next-btn"
            className="inline-flex items-center gap-2 rounded-full bg-gold px-7 py-2.5 text-sm font-semibold text-[#0B132B] transition-all hover:bg-[#E5C158]"
          >
            Continue <ArrowRight className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
};
